/** Public anmälning landing links (?i= signed token from API). */

export const ANMALNING_LINK_LANGUAGES = ["sv", "en", "pt", "es"];

/**
 * @param {string|null|undefined} raw
 * @returns {"sv"|"en"|"pt"|"es"|null}
 */
export function normalizeAnmalningLinkLang(raw) {
  const code = String(raw || "").trim().toLowerCase().slice(0, 2);
  return ANMALNING_LINK_LANGUAGES.includes(code) ? code : null;
}

/**
 * @param {string} search
 * @returns {"sv"|"en"|"pt"|"es"|null}
 */
export function getAnmalningLangFromSearch(search) {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  return normalizeAnmalningLinkLang(params.get("lang") ?? params.get("locale"));
}

/**
 * @param {{ origin?: string; token: string; lang?: string|null; relative?: boolean }} opts
 * @returns {string}
 */
export function buildAnmalningPublicLink({ origin, token, lang = null, relative = false }) {
  if (!token) return "";
  const code = normalizeAnmalningLinkLang(lang);
  const query = `i=${encodeURIComponent(token)}${code ? `&lang=${code}` : ""}`;
  if (relative) {
    return `/anmalning?${query}`;
  }
  const base = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  return `${base}/anmalning?${query}`;
}

/**
 * @param {{ origin?: string; token: string; groupId: string|number; lang?: string|null; relative?: boolean }} opts
 * @returns {string}
 */
export function buildAnmalningApplyLink({ origin, token, groupId, lang = null, relative = false }) {
  if (!token || groupId == null || groupId === "") return "";
  const code = normalizeAnmalningLinkLang(lang);
  const query = `i=${encodeURIComponent(token)}&groupId=${encodeURIComponent(String(groupId))}${
    code ? `&lang=${code}` : ""
  }`;
  if (relative) {
    return `/anmalning/ansok?${query}`;
  }
  const base = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  return `${base}/anmalning/ansok?${query}`;
}

/**
 * @param {string} search
 * @returns {string|null}
 */
export function getAnmalningTokenFromSearch(search) {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const raw = params.get("i") ?? params.get("token");
  if (raw == null || String(raw).trim() === "") return null;
  return String(raw).trim();
}
